// import { Project } from '@verantos-dev/data-access-projects';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { ActionMenu, ActionMenuItemProps } from '@verantos-dev/shared-components';
import { ProjectDetail } from '@verantos-dev/types-projects';

import { ProjectDialogType, useProjectModalContext } from '../../context/modalContext';

type ProjectListActionMenuProps = {
  project: ProjectDetail;
};

export const ProjectListActionMenu = ({ project }: ProjectListActionMenuProps) => {
  const intl = useIntl();
  const { openDialog } = useProjectModalContext();

  const menu: ActionMenuItemProps[] = useMemo(
    () => [
      {
        id: `projectActionMenu-deleteProject-${project.projectId}`,
        label: intl.formatMessage({ id: 'projectsList.actionMenu.delete.label' }),
        onClick: () => openDialog(ProjectDialogType.DELETE_PROJECT, project.projectId),
        icon: 'delete',
      },
    ],
    [intl, openDialog, project.projectId]
  );

  return <ActionMenu id={`projectListV2ActionMenu`} menuItems={menu} stopClickEventPropagation />;
};
